import React from "react";
import { useTranslation } from "react-i18next";

const INCIDENT_STATUS_CONFIG = {
    investigating: { color: "bg-amber-500", label: "statusPage.incident.investigating" },
    identified: { color: "bg-orange-500", label: "statusPage.incident.identified" },
    monitoring: { color: "bg-blue-500", label: "statusPage.incident.monitoring" },
    resolved: { color: "bg-emerald-500", label: "statusPage.incident.resolved" },
};

function IncidentList({ incidents }) {
    const { t } = useTranslation();

    if (!incidents || incidents.length === 0) {
        return (
            <div className="text-center py-8 border border-dashed border-gray-200 rounded-xl">
                <p className="text-gray-400 text-sm">{t("statusPage.noIncidents")}</p>
            </div>
        );
    }

    return (
        <div className="space-y-3">
            {incidents.map((incident) => {
                const config = INCIDENT_STATUS_CONFIG[incident.status] || INCIDENT_STATUS_CONFIG.investigating;
                return (
                    <div key={incident.id} className="p-4 rounded-xl border border-gray-100 bg-white">
                        <div className="flex items-start justify-between gap-3">
                            <div className="space-y-1">
                                <h4 className="font-medium text-gray-900 text-sm">{incident.title}</h4>
                                <p className="text-xs text-gray-400">
                                    {new Date(incident.createdAt).toLocaleDateString(undefined, {
                                        month: "short", day: "numeric", year: "numeric",
                                        hour: "2-digit", minute: "2-digit",
                                    })}
                                    {incident.resolvedAt && (
                                        <span> — {t("statusPage.incident.resolvedAt")} {new Date(incident.resolvedAt).toLocaleTimeString(undefined, {
                                            hour: "2-digit", minute: "2-digit",
                                        })}</span>
                                    )}
                                </p>
                            </div>
                            <div className="flex items-center gap-1.5 shrink-0">
                                <div className={`w-1.5 h-1.5 rounded-full ${config.color}`} />
                                <span className="text-xs font-medium text-gray-500">
                                    {t(config.label)}
                                </span>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}

export default IncidentList;
